export const tituloPrincipal ="Produção Atual"

export const graficos = 'Tipo de Gráfico:';

export const relatorioDiário = 'Relatório do gráfico';

export const dados = 'Fonte: Placas GoodWe';

export const subTitulo = 'Clima e Previsão';

export const impacto = 'Impacto Ambiental'

export const economia = 'Economia de CO₂';

export const descricaoEconomia = 'de CO₂ deixaram de ser emitidos';

export const arvoresEquivalentes = 'Árvores Equivalentes';

export const absorcaoPorArvore = 'árvores seriam necessárias para absorver essa CO₂'

export const reducaoPoluicao = 'Redução de Poluição';

export const impactoDescricao = 'A energia solar reduz a dependência de combustíveis fósseis, contribuindo para um futuro mais sustentável e saudável.';